import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { fetcher } from '@weezevent/weezjs-core';
import { Authentication } from './models/user/authentication.js';
import { PermissionsLayer } from './models/user/permissions.js';
import AppContextProvider from './context/appContextProvider.js';
import { FilterContextProvider } from './hooks/useFilters';

import { ToastProvider } from '@weezevent/nacre';
import { Loading } from './components';

import App from './app.js';

import '@weezevent/nacre/lib/index.css';
import '@weezevent/gallery-front/dist/index.css';
import '@weezevent/templar/dist/index.css';
import 'semantic-ui-css/semantic.css';
import './styles/main.scss';

// Lazy initialize Sentry - it's only needed after initial render
let Sentry = null;

const initSentry = async () => {
    if (!Sentry && window.weezConfig.sentry) {
        const module = await import('@sentry/browser');
        Sentry = module;
        return module;
    }
    return Sentry;
};

if (window.weezConfig.sentry) {
    initSentry().then(SentryModule => {
        if (SentryModule) {
            SentryModule.init({
                dsn: window.weezConfig.sentry.dsn,
                beforeSend: (event, hint) => {
                    if (hint.originalException?.code === 403) {
                        return null;
                    }
                    return event;
                },
                ignoreErrors: [
                    'NetworkError',
                    'Network Error',
                    'Fetch Error',
                    'Failed to fetch',
                    'Load failed',
                    'Error requesting resource',
                    'ChunkLoadError',
                    'ResizeObserver loop completed with undelivered notifications.',
                    /^Error: [A-Za-z]{2}$/,
                    /^[A-Za-z]{2}$/,
                    'AbortError',
                    'The operation was aborted.'
                ],
                environment: window.location.host,
                release: 'sauron-' + (window.weezConfig.version || 'dev')
            });
            SentryModule.addEventProcessor(function(event) {
                event.tags ||= {};
                event.tags.route_path = window.location.pathname.replace(/\/([OE][0-9]+|[a-z0-9-]{36})\b/gi, '/[id]').slice(0, 200);
                return event;
            });
        }
    });
}

function Sauron() {
    fetcher.initialize(window.weezConfig.api.apiUrl);

    return (
        <React.Suspense fallback={<Loading />}>
            <ToastProvider>
                <Router>
                    <Authentication config={window.weezConfig.connect} redirectPath="/">
                        <PermissionsLayer>
                            <AppContextProvider>
                                <FilterContextProvider>
                                    <Route path="/">
                                        <App />
                                    </Route>
                                </FilterContextProvider>
                            </AppContextProvider>
                        </PermissionsLayer>
                    </Authentication>
                </Router>
            </ToastProvider>
        </React.Suspense>
    );
}

ReactDOM.render(<Sauron />, document.getElementById('main'));
